class DescriptionTab extends HTMLElement {
  constructor() {
    super();

    this.init();
  }

  init() {
    const tabs = this.querySelectorAll(".description-title__btn");
    tabs.forEach((tab) => {
      tab.addEventListener("click", this.tabClick.bind(this));
    });
  }

  tabClick(event) {
    const clickedTab = event.target;
    if (this.classList.contains('returns-tab') && !clickedTab.classList.contains('desc-active')) {
      this.openTabReturns();
    }
    clickedTab.classList.toggle("desc-active");
    clickedTab.classList.toggle('rotate');
    // if(clickedTab === this.activeTab) {
    //   clickedTab.classList.remove("desc-active");
    //   this.activeTab = null;
    // } else {
    //   clickedTab.classList.add("desc-active");
    //   this.activeTab = clickedTab;
    // }
  }

  reInitTabs(description) {
    // reset the tab elements
    this.innerHTML = "";
    var number = 0;
    const headingTag = description.includes("<h6>") ? "h6" : "h2"; // Se agrego la posibilidad de usar H2 o H6 para poder actualizar la jerarquia del PDP sin romper compatibilidad
    const description_arr = description.split(`<${headingTag}>`);

    this.innerHTML = description_arr.map((desc) => {
      if(!desc || desc === "") { return `` }
      else {
        const desc_title = desc.split(`</${headingTag}>`)[0];
        const desc_body = desc.split(`</${headingTag}>`)[1];
        const formattedText = desc_title.trim().toLowerCase().replace(" ", "-").replace(":", "");
        number += 1;
        return `<div class="description-title tab-${number}">
          <h2 id="${formattedText}" class="description-title__btn mpclick">
            ${desc_title}
          </h2>
          <div class="description-content">
            ${desc_body} 
          </div>
        </div>`;
      }
    }).join("");

    this.init();
  }

  openTabReturns(){
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({'event':'shipping_returns_open'});
  }
}

customElements.define("description-tab", DescriptionTab); 
